module.exports = __webpack_public_path__ + "img/pic1new3.f37c16c3.png";